import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Gym } from "../types";

export const useGymQuery = () => {
  return useQuery({
    queryKey: ["managerGyms"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("No user found");

      console.log("Fetching gyms for manager:", user.id);
      
      // Obtener el rol del usuario
      const { data: profile } = await supabase
        .from("profiles")
        .select("role")
        .eq("id", user.id)
        .single();

      // Si es manager, obtener los gimnasios que gestiona a través de gym_managers
      if (profile?.role === 'manager') {
        const { data: managedGyms, error } = await supabase
          .from("gyms")
          .select(`
            *,
            gym_managers!inner(*)
          `)
          .eq("gym_managers.manager_id", user.id);

        if (error) {
          console.error("Error fetching managed gyms:", error);
          throw error;
        }

        console.log("Fetched managed gyms:", managedGyms);
        return managedGyms as Gym[];
      }

      // Si es admin, obtener todos los gimnasios
      const { data: allGyms, error } = await supabase
        .from("gyms")
        .select(`
          *,
          gym_managers(*)
        `);

      if (error) {
        console.error("Error fetching gyms:", error);
        throw error;
      }

      console.log("Fetched all gyms:", allGyms);
      return allGyms as Gym[];
    },
  });
};